<template>
    <v-row>
        <v-col cols="8">
            <v-card>
                <v-card-title>
                    {{ messageGroup.messageGroup }}
                </v-card-title>
                <v-card-text>
                    <v-data-table
                        :headers="headers"
                        :items="messageGroup.messageGroupMembers"
                    >
                        <template v-slot:no-data>
                            No members added yet!
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: 'MessageGroupDetail',
    props: {
        messageGroup: {
            type: Object,
            required: true,
            default: () => ({
                uid: '',
                messageGroup: '',
                messageGroupMembers: ''
            })
        }
    },
    data() {
        return {
            headers: [
                { text: 'First Name', align: 'left', value: 'firstName' },
                { text: 'Last Name', align: 'left', value: 'lastName' },
                { text: 'Email', align: 'center', value: 'email' },
                {
                    text: 'Location',
                    align: 'center',
                    value: 'location.location'
                },
                {
                    text: 'Actions',
                    align: 'center',
                    value: 'action',
                    sortable: false
                }
            ]
        };
    }
};
</script>
